import React from 'react'

import ChromePng from './chrome.png';

export const ChromeIcon = () => {
  return <img src={ChromePng} alt="Ícone do Chrome" />
}